import { useMutation, useQueryClient } from "@tanstack/react-query";
import productApi from "../services/productApi";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  PRODUCT_MESSAGES_ERROR,
  PRODUCT_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => productApi.enable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(PRODUCT_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(PRODUCT_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["products-filter"] });
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
    onError: () => {
      errorNotification(PRODUCT_MESSAGES_ERROR.ENABLE_ERROR);
    },
  });
};

export const useDisableProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => productApi.disable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(PRODUCT_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(PRODUCT_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["products-filter"] });
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
    onError: () => {
      errorNotification(PRODUCT_MESSAGES_ERROR.DISABLE_ERROR);
    },
  });
};
